import React, {useContext} from 'react';
import {observer} from "mobx-react";
import PropTypes from "prop-types";
import MenuItemInput from "./MenuItemInput";
import {Button} from "@dts-soldel/dts-react-common";
import MobXContext from "../../../../app/mobx/MobXContext";

const propTypes = {
	allowSubMenuItems: PropTypes.bool.isRequired,
	menu: PropTypes.arrayOf(PropTypes.object).isRequired,
};
const defaultProps = {};

const MenuInput = ({allowSubMenuItems, menu}) => {
	const {configuratorStore} = useContext(MobXContext);

	return (
		<div className="menu-input__container">
			<div className="menu-input__header">
				<Button
					label="Add Menu Item"
					onClick={() => configuratorStore.addMenuItemToMenu(menu)}
				/>
			</div>
			{(menu || []).map(menuItem => <MenuItemInput key={menuItem.id} menuItem={menuItem} allowSubMenuItems={allowSubMenuItems}/>)}
		</div>
	);
};

MenuInput.propTypes = propTypes;
MenuInput.defaultProps = defaultProps;

export default observer(MenuInput);
